import { render, staticRenderFns } from "./TakePhoto.vue?vue&type=template&id=00503068"
import script from "./TakePhoto.vue?vue&type=script&lang=js"
export * from "./TakePhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports